import { render, staticRenderFns } from "./GmbAttributesPreview.vue?vue&type=template&id=6329b2e2&scoped=true&"
import script from "./GmbAttributesPreview.vue?vue&type=script&lang=js&"
export * from "./GmbAttributesPreview.vue?vue&type=script&lang=js&"
import style0 from "./GmbAttributesPreview.vue?vue&type=style&index=0&id=6329b2e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6329b2e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
